/* vl-hero: minimal slider (loop, dots, arrows, optional autoplay)
   + slide add-to-cart buttons (data-add-handles="handle:qty,handle:qty"). */
(function () {
  'use strict';

  class VlSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vl-hero__track');
      this.slides = [...this.querySelectorAll('.vl-hero__slide')];
      this.dots = [...this.querySelectorAll('.vl-hero__dot')];
      this.index = 0;
      if (!this.track || this.slides.length < 2) return;

      /* slides after the first carry data-src / data-srcset (sections/vl-hero.liquid): fetched after the page has
         loaded, or at once when a slide is asked for — never in the same window as the first slide's LCP image */
      this.hydrate = (slide) => {
        slide.querySelectorAll('[data-srcset], [data-src]').forEach((el) => {
          if (el.dataset.srcset) { el.setAttribute('srcset', el.dataset.srcset); delete el.dataset.srcset; }
          if (el.dataset.src) { el.setAttribute('src', el.dataset.src); delete el.dataset.src; }
        });
      };
      const hydrateRest = () => this.slides.forEach((sl, i) => { if (i !== this.index) this.hydrate(sl); });
      const afterLoad = () => { const idle = window.requestIdleCallback || ((f) => setTimeout(f, 300)); idle(hydrateRest); };
      if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });

      const step = (i) => { this.go(i); this._play?.(); };
      this.querySelector('.vl-hero__arrow--prev')?.addEventListener('click', () => step(this.index - 1));
      this.querySelector('.vl-hero__arrow--next')?.addEventListener('click', () => step(this.index + 1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => step(i)));

      this.track.addEventListener('scroll', () => {
        clearTimeout(this._t);
        this._t = setTimeout(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) { this.index = i; this.paint(); }
        }, 80);
      }, { passive: true });

      const delay = parseInt(this.dataset.autoplay || '0', 10);
      const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (delay > 0 && !calm.matches) {
        this._play = () => {
          clearInterval(this._auto);
          this._auto = setInterval(() => { if (!document.hidden) this.go(this.index + 1); }, delay);
        };
        this._stop = () => clearInterval(this._auto);
        /* hold still while someone is reading, touching or tabbing through a slide */
        ['pointerenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, this._stop, { passive: true }));
        ['pointerleave', 'focusout', 'touchend'].forEach((e) => this.addEventListener(e, this._play, { passive: true }));
        document.addEventListener('visibilitychange', () => (document.hidden ? this._stop() : this._play()));
        this._play();
      }
      this.paint();
    }

    disconnectedCallback() {
      clearInterval(this._auto);
    }

    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n; /* loop */
      if (this.hydrate) this.hydrate(this.slides[this.index]);
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'smooth' });
      this.paint();
    }

    paint() {
      this.dots.forEach((d, i) => d.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
    }
  }
  if (!customElements.get('vl-slider')) customElements.define('vl-slider', VlSlider);

  /* add-to-cart CTAs (same flow as the live campaign buttons) */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-add-handles]');
    if (!btn || btn.dataset.loading) return;
    e.preventDefault();
    const entries = btn.dataset.addHandles.split(',').map(function (s) {
      const p = s.trim().split(':');
      return { handle: p[0], quantity: parseInt(p[1] || '1', 10) };
    }).filter(function (x) { return x.handle; });
    if (!entries.length) return;

    btn.dataset.loading = '1';
    btn.setAttribute('disabled', '');
    const label = btn.textContent;
    btn.textContent = 'Ekleniyor...';

    Promise.all(entries.map(function (en) {
      return fetch('/products/' + en.handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { return { id: p.variants[0].id, quantity: en.quantity }; });
    }))
      .then(function (items) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('vl-hero add failed:', err);
        btn.textContent = label;
        btn.removeAttribute('disabled');
        delete btn.dataset.loading;
        alert('Ürün sepete eklenemedi, lütfen tekrar deneyin.');
      });
  });
})();
